import store from '../../stores/store'
import router from '../../router'

export const search = (result, mode) => {
  console.log(`Scanned: ${result.text}`)
  const query = {
    query: result.text,
    barcode: result.barcodeText,
    barcodeFormat: result.barcodeFormat,
    barcodeFormatString: result.barcodeFormatString,
    scan: true
  }

  if(mode == 'vShow'){
    router.push({path: '/virtual_show'})
    store.dispatch('vShowCameraSearch', {query: query.query})
  }else{
    router.push({name: 'ProductSearch', query})
  }
}